<template>
  <div class="imgs" v-if="!type">
    <div v-for="(item, index) in list">
      <a :href="item.href">
        <img :src="item.src" alt="" />
      </a>
    </div>
  </div>
  <van-swipe v-else class="imgs" :autoplay="3000" indicator-color="white">
    <van-swipe-item v-for="(item, index) in list">
      <a :href="item.href">
        <img :src="item.src" alt="" />
      </a>
    </van-swipe-item>
  </van-swipe>
</template>

<script setup>
import { toRefs } from "vue";

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: "",
  },
});

const { list } = toRefs(props);
</script>

<style lang="scss" scoped>
.imgs {
  width: 100%;
  div {
    width: 100%;
    a {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
}
</style>